import React, { useEffect, useState } from "react"
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap"
import { Field, isDirty, reset } from "redux-form"
import { CheckboxField, TextField } from "components/RenderInput"
import { FORM_NAMES } from "constants/index"
import PhonePreview from "./phonePreview"
import { connect } from "react-redux"
import UnsavedAlertModal from "components/UnsavedAlertModal"
import BottomNavigation from "components/BottomNavigation"
import ColorPicker from "components/ColorPicker"

const ButtonTab = ({
  handleSave,
  handleNext,
  handleBack,
  isDirty,
  resetForm,
  tabIsActive,
}) => {
  const [showAlertModal, setShowAlertModal] = useState(false)

  useEffect(() => {
    if (!tabIsActive && isDirty) {
      setShowAlertModal(true)
    }
  }, [tabIsActive])

  return (
    <React.Fragment>
      <Row className="mt-3">
        <Col xl={8}>
          <Card>
            <CardHeader>
              <h4>
                Design and name the button to open the experience list area
              </h4>
            </CardHeader>
            <CardBody>
              <Row>
                <span>
                  <b>NOTE:</b> Please review your changes in the app. The font
                  may need to be updated in order for the text to fit in certain
                  areas of the app.
                </span>
              </Row>
              <Row className="my-3">
                <Col
                  xs={12}
                  sm={3}
                  md={2}
                  style={{ minWidth: "fit-content" }}
                  className="mt-2"
                >
                  <label>Color:</label>
                </Col>
                <Col xs={"auto"}>
                  <Field name="button_color" component={ColorPicker} />
                </Col>
              </Row>
              <Row className="my-3">
                <Col
                  xs={12}
                  sm={3}
                  md={2}
                  style={{ minWidth: "fit-content" }}
                  className="mt-2"
                >
                  <label>Text:</label>
                </Col>
                <Col xs={"auto"}>
                  <Field
                    name="button_text"
                    component={TextField}
                    placeholder="Button Text"
                  />
                </Col>
              </Row>
              <Row className="my-3">
                <Col
                  xs={12}
                  sm={3}
                  md={2}
                  style={{ minWidth: "fit-content" }}
                  className="mt-2"
                >
                  <label>Font Color:</label>
                </Col>
                <Col xs={"auto"}>
                  <Field name="text_color" component={ColorPicker} />
                </Col>
              </Row>
              <Row className="my-4">
                <Col xs={"auto"}>
                  <Field
                    name="requireLogIn"
                    label="Require Log In"
                    component={CheckboxField}
                  />
                </Col>
              </Row>
            </CardBody>
          </Card>
          <BottomNavigation
            handleSave={handleSave}
            handleBack={handleBack}
            handleNext={handleNext}
          />
        </Col>
        <Col xl={4} className="mt-4 d-none d-xl-block">
          <PhonePreview />
        </Col>
      </Row>
      <UnsavedAlertModal
        isOpen={showAlertModal}
        onClose={() => {
          setShowAlertModal(false)
          resetForm()
        }}
        onSave={() => {
          handleSave()
          setShowAlertModal(false)
        }}
      />
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  isDirty: isDirty(FORM_NAMES.LANDING_SCREEN)(state, ...["button"]),
})

const mapDispatchToProps = dispatch => ({
  resetForm: () => dispatch(reset(FORM_NAMES.LANDING_SCREEN)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ButtonTab)
